import { IPositionResponse } from 'services';
import { IPosition } from 'views/pages/ExpertiseManagement/Position/position.interface';

function convertPositionToDetailsView(position: IPositionResponse): IPosition {
  const { id, name, orderNo, knowledgeAreas } = position;
  return {
    id,
    name,
    knowledgeAreas,
    orderNo,
  };
}

export { convertPositionToDetailsView };
